import { client } from "./index";

// params: category, search, minPrice, maxPrice, sort (featured|low|high|name|newest), availability, page, limit
export const getProducts = (params = {}) => client.get("/storefront/products", { params }).then((res) => res.data);

// The home page's Featured section: the owner's pick, or the newest 12 products
export const getFeaturedProducts = () => client.get("/storefront/products/featured").then((res) => res.data.products);

// The home page: { total, rows: [{ category, total, products }] }, every category with its first products
export const getHomeRows = () => client.get("/storefront/products/home").then((res) => res.data);

// The home page's Offers row, in the owner's order
export const getOfferProducts = () => client.get("/storefront/products/offers").then((res) => res.data.products);

export const getProductById = (productId) => client.get(`/storefront/products/${productId}`).then((res) => res.data);

export const getProductReviews = (productId, params = {}) =>
    client.get(`/storefront/products/${productId}/reviews`, { params }).then((res) => res.data);

// Suggestions on a product page: { similar, completeLook, boughtTogether } (backend services/recommendations.js)
export const getRecommendations = (productId, params = {}) =>
    client.get(`/storefront/products/${productId}/recommendations`, { params }).then((res) => res.data);

// "Picked for you": products like the ones this shopper viewed (ids, most recent first)
export const getRecommended = (seen, params = {}) =>
    client.get("/storefront/products/recommended", { params: { seen: seen.join(","), ...params } }).then((res) => res.data.products);

// A photo the shopper adds to a personalised gift (signed-in shoppers only): resolves to its address
export const uploadPersonalPhoto = (file) => {
    const form = new FormData();
    form.append("file", file);
    return client.post("/storefront/personal-photos", form).then((res) => res.data.url);
};
